import { render, staticRenderFns } from "./LegacySubscriptionList.vue?vue&type=template&id=41583505&scoped=true"
import script from "./LegacySubscriptionList.vue?vue&type=script&lang=js"
export * from "./LegacySubscriptionList.vue?vue&type=script&lang=js"
import style0 from "./LegacySubscriptionList.vue?vue&type=style&index=0&id=41583505&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41583505",
  null
  
)

export default component.exports